import {CREATE, DELETE, GET_ALL, GET_BY_ID, GET_BY_PATIENT, UPDATE} from './Constants'; 
import {rqCreateRequest} from './rqHttpUtils';

export const getBills = token => {
  return rqCreateRequest(
    GET_ALL,
    null,
    token,
    null,
    null,
  );
};

// ==================================================
// GET BILL BY ID
// ==================================================

export const getBillById = (
  billId,
  token,
) => {
  return rqCreateRequest(
    GET_BY_ID,
    null,
    token,
    {billId},
    null,
  );
};

// ==================================================
// GET BILLS BY PATIENT
// ==================================================

export const getBillsByPatient = (
  patientId,
  token,
) => {
  return rqCreateRequest(
    GET_BY_PATIENT,
    null,
    token,
    {patientId},
    null,
  );
};

// ==================================================
// CREATE BILL
// ==================================================

export const createBill = (
  billData,
  token,
) => {
  return rqCreateRequest(
    CREATE,
    billData,
    token,
    null,
    null,
  );
};

// ==================================================
// UPDATE BILL
// ==================================================

export const updateBill = (
  billId,
  billData,
  token,
) => {
  return rqCreateRequest(
    UPDATE,
    billData,
    token,
    {billId},
    null,
  );
};

// ==================================================
// DELETE BILL
// ==================================================

export const deleteBill = (
  billId,
  token,
) => {
  return rqCreateRequest(
    DELETE,
    null,
    token,
    {billId},
    null,
  );
};
